import {writeStore} from '../helpers'

// A 'resetTable' flag is used to prevent infinity renders. Resetting both means editing the tanStack cache and our own Redux cache.

export const startResetTable = ({tableName}) => {
	writeStore(tableName, {resetTable: true})
}

export const finishResetTable = ({tableName}) => {
	writeStore(tableName, {resetTable: false})
}
